import { render, staticRenderFns } from "./TransportModeComparison.vue?vue&type=template&id=497c70ee"
import script from "./TransportModeComparison.vue?vue&type=script&lang=js"
export * from "./TransportModeComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports